<template>
  <div>
    <section class="w" id="pic">
      <!-- <div v-if="navImg" class="flex"> -->
        <figure class="picImage" v-if="navImg.navImg1">
          <img :src="navImg.navImg1"/>
          <figcaption class="figcaptionText">
            <P>{{ navImg.navdesc1 }}</P>
            <a href="#">推荐</a>
          </figcaption>
        </figure>
        <figure class="picImage" v-if="navImg.navImg2">
          <img :src="navImg.navImg2"/>
          <figcaption class="figcaptionText">
            <P>{{ navImg.navdesc2 }}</P>
            <a href="#">推荐</a>
          </figcaption>
        </figure>
        <figure class="picImage" v-if="navImg.navImg3">
          <img :src="navImg.navImg3"/>
          <figcaption class="figcaptionText">
            <P>{{ navImg.navdesc3 }}</P>
            <a href="#">推荐</a>
          </figcaption>
        </figure>
      <!-- </div> -->
      <div v-else class="flex">
        <figure class="picImage" v-for="item in 3" :key="item">
          <img :src="require(`./../../../public/images/article/${item}.jpg`)" />
          <figcaption class="figcaptionText">
            <P>桃花恋芯片的</P>
            <a href="#">推荐</a>
          </figcaption>
        </figure>
      </div>
    </section>
  </div>
</template>
<script>
// import { defineComponent } from '@vue/composition-api'
export default {
  name: "c-section",
  data() {
    return {
      navImg: {}
    };
  },
  mounted() {
    this.navImg = myconfig;
  }
};
</script>

<style lang="scss" scoped>
#pic {
  display: flex;
  p {
    height: 75px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    width: 260px;
    text-overflow: ellipsis;
    display: -webkit-box;
    display: -moz-box;
    word-wrap: break-word;
    margin-bottom: 6px;
  }
}
.figcaptionText {
  font-size: 14px;
}
</style>